// extracted by mini-css-extract-plugin
export default {"control":"Control_control__wPVO+","button":"Control_button__JMGoW","approved":"Control_approved__KvnaJ","rejected":"Control_rejected__AkthP"};